module.exports = __webpack_public_path__ + "static/media/mars-1.72e6f188.jpg";